import { convertToExportedView } from '@estee/elc-service';
import { PRODUCT_SHADE_PICKER_BUTTON } from '@estee/elc-service-view-names';
import { IProductShadePickerButton } from 'src/internal/views/product-shade-picker/ProductShadePickerButtonWrapper';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IProductShadePickerButton>(
    () => import('../../internal/views/product-shade-picker/ProductShadePickerButtonWrapper'),
    PRODUCT_SHADE_PICKER_BUTTON
);
